export default "__VITE_ASSET__B8zORIuM__"